<style scoped lang="sass">
@use '../../styles/variables.scss' as *

.maintenance-card
  position: relative
  width: 100%
  max-width: 480px
  border-radius: 10px
  border-top: 4px solid $main-primary-color

.title
  color: $text-primary-color
  font-size: 1.75rem
  font-weight: 700
  line-height: 1.2

.message
  color: $text-black-color
  font-size: 1rem
  line-height: 1.6

.status
  display: inline-flex
  align-items: center
  gap: 10px
  padding: 8px 16px
  border-radius: 999px
  background: rgba($main-primary-color, 0.08)
  color: $text-grey-dark
  font-size: 0.8125rem
  line-height: 1.4
  text-align: left

.status-dot
  position: relative
  flex-shrink: 0
  width: 8px
  height: 8px
  border-radius: 50%
  background: $main-primary-color

  &::after
    content: ''
    position: absolute
    inset: 0
    border-radius: 50%
    background: $main-primary-color
    animation: pulse 2s ease-out infinite

@keyframes pulse
  0%
    transform: scale(1)
    opacity: 0.6
  100%
    transform: scale(2.8)
    opacity: 0

@media (prefers-reduced-motion: reduce)
  .status-dot::after
    animation: none
</style>

<template>
  <v-card class="maintenance-card text-center px-8 pt-10 pb-8" elevation="5">
    <v-img
      v-if="showLogo"
      src="@/assets/logo.jpg"
      alt="Grupo Puntacana"
      width="220"
      class="mx-auto mb-8"
    />

    <h1 class="title mb-4">{{ title }}</h1>

    <p class="message mb-8">{{ message }}</p>

    <div class="status" role="status">
      <span class="status-dot" aria-hidden="true"></span>
      {{ status }}
    </div>

    <div v-if="$slots.actions" class="mt-8">
      <slot name="actions" />
    </div>
  </v-card>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  // Aviso de que la página se recupera sola al apagar el flag
  status: {
    type: String,
    required: true,
  },
  showLogo: {
    type: Boolean,
    default: true,
  },
});
</script>
